import { useState } from 'react';

import muscleManUrl from '../../../../images/illustrations/Muscle-Man@2x.png';
import { Button } from '../../../cdl/Button/Button';
import { Modal } from '../../../cdl/Modal/Modal';
import { Text } from '../../../cdl/Text/Text';
import { translate } from '../../../common/helpers/translate.helper';
import { Box } from '../../../common/ui/Box';
import {
    getShowWelcomePopupFromStorage,
    storeShowWelcomePopupInStorage,
} from '../../../common/utils/showWelcomePopup.util';

export const WelcomePopup = () => {
    const [showWelcomePopupState, setShowWelcomePopupState] = useState(getShowWelcomePopupFromStorage());

    return (
        <Modal isOpen={showWelcomePopupState} scrollable={false} dismissible={false} size="small">
            <Box padding={48} style={{ textAlign: 'center' }}>
                <img src={muscleManUrl} width={150} height={150} alt="" />
                <Text variant="display" as="h1" marginTop={24} marginBottom={8}>
                    {translate('welcomePopup.youHaveMadeIt')}
                </Text>
                <Text variant="body" color="foreground.muted" as="p" marginBottom={16}>
                    {translate('welcomePopup.welcomeOnBoard')}
                </Text>

                <Button
                    width="100%"
                    emphasis="high"
                    onClick={() => {
                        setShowWelcomePopupState(false);
                        storeShowWelcomePopupInStorage(false);
                    }}
                >
                    {translate('welcomePopup.letsGetStarted')}
                </Button>
            </Box>
        </Modal>
    );
};
